import { Fragment, useContext, useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ProcessContext from '../../../contexts/process/ProcessContext';
import UIContext from '../../../contexts/ui/UIContext';
import StatusBarButton from '../../layout/StatusBarButton';
import TransplantingOverview from './overview/TransplantingOverview';
import Loading from '../../ui-elements/Loading';


const ConfirmTransplanting = ({ completingRef }) => {
  const { activeProcessId, activeProcessType, taskData, continueProcess, notifyError, additionalProcessInformation, processes, finishProcess } = useContext(ProcessContext);
  const { loading, setInfo, clearInfo } = useContext(UIContext);

  const navigate = useNavigate();
  const [, setConfirmed] = useState(false);

  useEffect(() => {
    clearInfo()

 let processTypeStr = ''
   if (typeof activeProcessType === 'string') {
     processTypeStr = activeProcessType
   } else if (typeof activeProcessType === 'number') {
     const found = processes.find(p => p.type === activeProcessType)
     processTypeStr = found?.title || ''
   }
    const base = processTypeStr.replace(/ing$/i, '')
    const processType = base.toUpperCase() || '—'
    const tray  = additionalProcessInformation.sourceEntity   // z.B. 'T5'
    const panel = additionalProcessInformation.destinationEntity      // z.B. 'P10'
    const plants = Array.isArray(additionalProcessInformation.selectedSeedSlotOrdinalNumbers)
    ? additionalProcessInformation.selectedSeedSlotOrdinalNumbers.length : 0

    setInfo({ processType, tray, panel, plants})
  }, [])

  const confirmTransplanting = useCallback(async () => {
    try {
      setConfirmed(true);
      await continueProcess(activeProcessId, true);
      if (completingRef) {
        completingRef.current = true;
        await finishProcess();
      }

      if (taskData){
        if (taskData.redirectUrl) {
          window.location.href = taskData.redirectUrl;
          return;
        } else {
          navigate('/', { state: { slide: 1 } });
          return;
        }
      }

      navigate('/');
    } catch (error) {
      notifyError(<>We have encountered a problem while continuing the Process. Please contact the support team {HELP_DESK_LINK}.</>)
      console.error(error);
    }
  }, [activeProcessId, continueProcess]);

  return loading ? (
    <Loading fullScreen />
  ) : (
    <Fragment>
      {/* {!confirmed ??  */}
        <TransplantingOverview />
        {/* } */}
      <StatusBarButton
        label='Confirm'
        icon='fas fa-check'
        reversed={true}
        clickHandler={confirmTransplanting}
        statusSlot={5}
      />
    </Fragment>
  );
};

export default ConfirmTransplanting;
